import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient,} from '@angular/common/http';
import { GridOptions } from "ag-grid/main";
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CommonUtility, EmploymentPlanSummary, WpPerson, EDIT_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility, EmploymentPlan, VIEW_BTN } from '../shared';
import { DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService, SINGLE_ROW_HEADER, PAGE_CONSTANTS } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { EmploymentPlansSummary } from '../shared/model/employment-plans-summary.model';

@Component({
  selector: 'app-employment-plan-summary',
  templateUrl: './employment-plan-summary.component.html',
  styleUrls: ['./employment-plan-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class EmploymentPlanSummaryComponent implements OnInit {
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  PAGE_CONSTANTS = PAGE_CONSTANTS;
  employmentPlan: EmploymentPlan;
  sortedEmploymentPlan: EmploymentPlan;
  enrollmentId: Number;
  employmentPlans: EmploymentPlan[];
  employmentPlansCopy1: EmploymentPlan[];
  employmentPlansCopy: EmploymentPlan[];
  employmentPlanSummary: EmploymentPlanSummary;
  programMap: any;
  relationshipArray: any[];
  relationshipMap: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  suggestions: any = [];
  suggestionsUser: any = [];
  ServerConstants: any;
  userActionNotificationsMap: any;
  refData: any;
  sharedData: any;
  currentSearch: String;
  wpenrollmentId: string = '';
  wpPersonId: string = '';
  noData: Boolean = false;
  error: Boolean = false;
  isAddRequired:boolean=false;
  caseNoteMap: any;
  private gridOptions: GridOptions;
  columnDefs: any;
  context: any;
  taskTypesJson: any;
  taskStatusJson: any;
  countiesJson: any;
  countiesMap: any;
  counties: any;
  assignedToJson: any;
  assignedToMap: any;
  assignedToDD: any;
  empPlanStatusMap: any;
  shortTermGoalMap: any;
  longTermGoalMap: any;
  shortTermGoalArray: any[];
  longTermGoalArray: any[];
  empPlanStatusArray: any[];
  wpPerson: WpPerson;
  private _success = new Subject<string>();
  successMessage: string;
  private _danger = new Subject<string>();
  errorMessage: string;
  selectedEnrollment: number;
  auditColumnDefs: any; //audit
  auditElements: { label: any, value: any }[] = [];
  index:any;
  assessmentStartDate: any;
  isassessmentPending = false;
  addBtn: any = "-1";

  isDisable: boolean;
  gridApi: any;
  tabToNextCell : any;
  firstTime: Boolean = true;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private dateUtility: DateUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('EMPPL') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    //Initialize class variables
    this.index = this.dataService.getSharedDataObject().get("EMPPL").innerNavPages.find(x=> x.pageId === 'EMPSU');
    if (this.index.readOnly === true) {
      this.addBtn = "0";
    }
    this.isDisable = this.isComponentDisabled();
    this.noData = false;
    this.sharedData = this.dataService.getSharedDataObject();
    this.employmentPlan = new EmploymentPlan();
    this.employmentPlanSummary = new EmploymentPlanSummary();
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.employmentPlanSummary.etEnrollmentId = Number(this.sharedData.get('etEnrollment').id);
    }
    this.wpenrollmentId = this.sharedData.get('etEnrollment').id;
    this.http.post<any[]>(this.ServerConstants.SERVER_API_URL + '/assessment-summary/getLatestCompletedAssessment',
      {
        "enrollmentId": this.wpenrollmentId
      }).subscribe(data => {
        console.log('data: ' + data);
        if(data != null && data != undefined) {
          this.assessmentStartDate = data['createdDt'];
          if (this.employmentPlanSummary.etEnrollmentId == data['etEnrollmentId'] && data['statusCd'] === 'CO') {
            this.isassessmentPending = false;
            this.addBtn = "-1"
          }
        } 
      
        console.log('this.isassessmentPending-' +this.isassessmentPending);
    })

    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });

      if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
        const request = new RequestLoadAll(parseInt(this.sharedData.get('wpPersonId')));
        this.load(request);
      }         
  
      console.log('PersonID ' +  this.sharedData.get('wpPersonId'));
    //this.load(this.employmentPlan);

    // Employment Paln Column Definations
    this.getAuditColumnDefs();
    // Employment Paln Audit Column Definations
    this.getColumnDefinitions();
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Employment ID',
        field: 'id',
        width: 155,
      },
      {
        headerName: 'Start Date',
        field: 'empPlanStartDt',
        filter: "agDateColumnFilter",
        width: 135,
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
        ,
      },
      {
        headerName: 'End Date',
        width: 125,
        field: 'estimatedCompletionDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
        ,
      },
      {
        headerName: 'Completed By',
        width: 155,
        field: 'createdBy',
        filter: "agTextColumnFilter",
      },
      {
        headerName: 'Status',
        field: 'empPlanStatusCd',
        width: 100,
        refData: this.empPlanStatusMap,
      },
      {
        headerName: 'Enrollment End Date',
        field: 'enrollmentEndDt',
        width: 155,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        width: 100,
        cellStyle: { 'text-align': 'center !important' ,
          suppressFilter: true,
          suppressSorting: true},
      }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  getAuditColumnDefs() {
    this.auditColumnDefs = [
      {
        headerName: 'Employment Plan',
        field: 'id',
        tooltipField: 'id'
      },
      { headerName: 'Employement Plan Status',
        field: 'empPlanStatusCd',
        refData: this.empPlanStatusMap,
        width: 200,
        tooltip: (params) => {
          const empPlanStatusMap = params.context.empPlanStatusMap;
          const empPlanStatusCode = params.data.empPlanStatusCd;
          const empPlanStatus = empPlanStatusMap[empPlanStatusCode];
          return empPlanStatus;
        }
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 160,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime,
      },
      {
        headerName: 'End Date',
        field: 'estimatedCompletionDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 150,
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Enrollment End Date',
        field: 'enrollmentEndDt',
        width: 155,
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    this.gridOptions.api.hideOverlay();
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }
  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
  formatDates(params) {
    if (!params.value) {
      return null;
    }
    const dateParts = params.value.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }


  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  getEditButton(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    // Edit Button
    const element = document.createElement('a');

    const viewImage = VIEW_BTN ;
    const editImage = EDIT_BTN;
    
    console.log('params.data.enrollmentEndDt  = '+ params.data.enrollmentEndDt);
    if(params.data.enrollmentEndDt != null && params.data.enrollmentEndDt != undefined && params.data.enrollmentEndDt != "Current"){
      element.innerHTML = viewImage;
    } else {
      element.innerHTML = editImage;
    }

    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('employmentPlan', params.data);
      that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
      delete params.data['enrollmentEndDt'];
      that.router.navigate(['/task/employmentPlanSummary/employmentPlan']);
    });

    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('employmentPlan', params.data);
        that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
        delete params.data['enrollmentEndDt'];
        that.router.navigate(['/task/employmentPlanSummary/employmentPlan']);
      }
      else if(event.keyCode == 9){
        //event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });

    element.setAttribute("tabindex", "0");

    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");

    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;

    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.EmploymentPlan');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Employment Plan Audit');
        that.router.navigate(['/task/employmentPlanSummary/auditHistory'])
      }
    });

    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.EmploymentPlan');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Employment Plan Audit');
      that.router.navigate(['/task/employmentPlanSummary/auditHistory'])
    });

    auditElement.setAttribute("tabindex", "0");
    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);
    return divRow;
  }

  load(request) {
    this.http.post<EmploymentPlansSummary>(this.ServerConstants.SERVER_API_URL + '/employmentplan/list', request).subscribe(
      (data: EmploymentPlansSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('EmploymentPlan Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            if (data.employmentPlans.length > 0) {
              this.employmentPlans = data.employmentPlans;
              this.employmentPlans.forEach(element => {
                if(this.employmentPlanSummary.etEnrollmentId == element.id && element.empPlanStatusCd ==="OP"){

                  this.isAddRequired=true;
                  this.addBtn = "0";
                }
                //var date=new Date();
                //element.estimatedCompletionDt=this.dateUtility.convertDateFromServer(element.estimatedCompletionDt);
                // date.setDate( element.estimatedCompletionDt.day);
                // date.setMonth(element.estimatedCompletionDt.month-1);
                // date.setFullYear(element.estimatedCompletionDt.year);
                // element.estimatedCompletionDt=date;
              });
              this.employmentPlans.sort((a, b) => new Date(b.estimatedCompletionDt).getTime() - new Date(a.estimatedCompletionDt).getTime());

              this.employmentPlans.forEach(element => {
                element.estimatedCompletionDt=this.dateUtility.formatDate(element.estimatedCompletionDt);

              });
              this.sortedEmploymentPlan = this.employmentPlans[0];

              let employmentPlanEndDate = new Date(this.sortedEmploymentPlan.estimatedCompletionDt);
              employmentPlanEndDate.setDate( employmentPlanEndDate.getDate() + 1 );
              let employmentPlanEndDateStr = this.dateUtility.convertObjectDateForServer(employmentPlanEndDate);
              this.dataService.addValueToSharedDataMap('employmentPlanEndDate', employmentPlanEndDateStr);

              this.dataService.addValueToSharedDataMap('EmploymentSummary', this.employmentPlans);
              console.log('this.isAddRequired -' +this.isAddRequired);
            } else {
              this.employmentPlans=[];
              this.noData = true;
              this.dataService.removeValueFromSharedDataMap('employmentPlanEndDate');
              this.dataService.removeValueFromSharedDataMap('EmploymentSummary');
            }
          }
        }
      }, response => {
        this.error = true;
        this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
      }, () => {
        this.error = false;
      });
  }
  parseRefTableData(myData) {
    if (myData != undefined && myData.englishDropDown) {
      this.empPlanStatusArray = myData.englishDropDown["EMPLOYMENT_PLAN_STATUS"];
      this.empPlanStatusMap = this.commonUtil.createNativeMapFromList(this.empPlanStatusArray);
      this.shortTermGoalArray = myData.englishDropDown["EMPLOYMENT_SHORT_TERM_GOAL"];
      this.shortTermGoalMap = this.commonUtil.createNativeMapFromList(this.shortTermGoalArray);
      this.longTermGoalArray = myData.englishDropDown["EMPLOYMENT_LONG_TERM_GOAL"];
      this.longTermGoalMap = this.commonUtil.createNativeMapFromList(this.longTermGoalArray);

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  loademploymentplanDetails() {
    this.dataService.addValueToSharedDataMap('assessmentStartDate', this.assessmentStartDate); 
    this.dataService.removeValueFromSharedDataMap('selectedEnrollmentEndDt');     
    console.log('selectedEnrollmentEndDt:' + this.dataService.getSharedDataObject().get('selectedEnrollmentEndDt'));
    console.log('Loading Emp Plan Page');
    this.router.navigate(['/task/employmentPlanSummary/employmentPlan']);
    this.dataService.removeValueFromSharedDataMap('employmentPlan'); 
  }

  // @params
  // Pass component ID
  isComponentDisabled() {
    return this.dataService.isComponentDisable(this.PAGE_CONSTANTS.EmploymentPlan);
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if ( event.keyCode !== tabKeyCode) {
      return;
    }

    if ( this.employmentPlans.length === 0) {
      return;
    }

    if( event.shiftKey ) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if ( !event.shiftKey && event.keyCode === 9 ) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

}

class RequestLoadAll {
  constructor(
    public personId: Number
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/employment-plan-summary/employment-plan-summary.component.ts